import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import { useRouter } from '@src/routes'
import { ListKits } from '@src/types/graphql-types'

const useStyles = makeStyles((theme: Theme) => ({
  searchCriteria: {
    marginTop: theme.spacing(4),
  },
}))

export interface SearchCriteriaProps {
  previouslyViewedKit: ListKits | null | undefined
}

const SearchCriteria: React.FC<SearchCriteriaProps> = ({
  previouslyViewedKit,
}) => {
  const classes = useStyles()
  const { query } = useRouter()

  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Typography variant="h2">
            <FormattedMessage
              id="REVIEW_SEARCH_CRITERIA"
              defaultMessage="review Search criteria"
            />
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h3">
            <FormattedMessage
              id="CONF_Crispr_Search_Criteria_crisprgrna"
              defaultMessage="Search Criteria"
            />
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} className={classes.searchCriteria}>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={2}>
            <p>
              <FormattedMessage id="SPECIES" defaultMessage="Species" />:
            </p>
          </Grid>
          <Grid item>
            <p>{query.species || previouslyViewedKit?.species}</p>
          </Grid>
        </Grid>
        {query.researchAreas && (
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={2}>
              <p>
                <FormattedMessage
                  id="FACET_WEB_ANTIBODY_RESEARCH_AREA"
                  defaultMessage="Research Area"
                />
                :
              </p>
            </Grid>
            <Grid item xs={10}>
              <p>
                {Array.isArray(query.researchAreas) &&
                query.researchAreas.length > 1
                  ? query.researchAreas.reduce((acc, res) => `${acc}, ${res}`)
                  : query.researchAreas}
              </p>
            </Grid>
          </Grid>
        )}

        <Grid container item xs={12} spacing={2}>
          <Grid item xs={2}>
            <p>
              <FormattedMessage id="ASSAY" defaultMessage="Assay" />:
            </p>
          </Grid>
          <Grid item>
            <p>{query.assay || previouslyViewedKit?.assayTypeSelection}</p>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default SearchCriteria
